/**
 * Prezentacja wartości. Baza trzyma daty w UTC — strefa `Europe/Warsaw` pojawia się
 * wyłącznie tutaj (CLAUDE.md §3).
 */

const DATA = new Intl.DateTimeFormat('pl-PL', { dateStyle: 'medium', timeZone: 'Europe/Warsaw' });

const DATA_I_CZAS = new Intl.DateTimeFormat('pl-PL', {
  dateStyle: 'short',
  timeStyle: 'short',
  timeZone: 'Europe/Warsaw',
});

export function data(wartosc: string | null | undefined): string {
  return wartosc ? DATA.format(new Date(wartosc)) : '';
}

export function dataICzas(wartosc: string | null | undefined): string {
  return wartosc ? DATA_I_CZAS.format(new Date(wartosc)) : '';
}

/** Data w postaci przyjmowanej przez `<input type="date">` i API. */
export function doPolaDaty(wartosc: string | null | undefined): string {
  return wartosc ? new Date(wartosc).toISOString().slice(0, 10) : '';
}

export function nip(wartosc: string | null | undefined): string {
  if (!wartosc || wartosc.length !== 10) return wartosc ?? '';
  return `${wartosc.slice(0, 3)}-${wartosc.slice(3, 6)}-${wartosc.slice(6, 8)}-${wartosc.slice(8)}`;
}

/** „3 braki" — polska odmiana, bo „3 braków" i „3 brak" kłują w oczy. */
export function braki(ile: number): string {
  if (ile === 1) return '1 brak';
  const dziesiatki = ile % 100;
  const jednosci = ile % 10;
  const mnoga = jednosci >= 2 && jednosci <= 4 && (dziesiatki < 12 || dziesiatki > 14);
  return `${ile} ${mnoga ? 'braki' : 'braków'}`;
}

export function takNie(wartosc: boolean | null | undefined): string {
  if (wartosc === null || wartosc === undefined) return '';
  return wartosc ? 'tak' : 'nie';
}
